module.exports = __webpack_public_path__ + "img/wheel.e5f66950.svg";